import { render, staticRenderFns } from "./ObjectsWorksProgress2.vue?vue&type=template&id=16b7e40d&"
import script from "./ObjectsWorksProgress2.vue?vue&type=script&lang=js&"
export * from "./ObjectsWorksProgress2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports